<section [ngClass]="urlScMobileForm? 'iframeSection' : null">
	<header>
		<label i18n>{{ env.project === 'CTT' ? "Авторизация в МСИ" : "Привязать ЭЦП-М" }}</label>
		<app-icon (click)="close(false)">close</app-icon>
	</header>
	<form *ngIf="!urlScMobileForm && !isAuthorizeMobileEds" [formGroup]="form">
		<div>
			<label i18n>Мобильный телефон</label>
			<app-phone-textbox formControlName="phoneNumber" placeholder="YY YYY-YY-YY" name="Мобильный телефон" class="phoneNumber"></app-phone-textbox>
		</div>
	</form>
	<iframe *ngIf="urlScMobileForm" [src]="url"></iframe>
	<footer>
		<button *ngIf="!urlScMobileForm && !isAuthorizeMobileEds" appSkin="action" class="green" (click)="confirmCertificate()" i18n>Привязать</button>
		<button appSkin="simple-cancel" (click)="close(false)" i18n>{{ urlScMobileForm || isAuthorizeMobileEds ? "Закрыть" : "Отмена" }}</button>
	</footer>
</section>
<app-overlay></app-overlay>
